"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfilePayrollDto = instanceOfProfilePayrollDto;
exports.ProfilePayrollDtoFromJSON = ProfilePayrollDtoFromJSON;
exports.ProfilePayrollDtoFromJSONTyped = ProfilePayrollDtoFromJSONTyped;
exports.ProfilePayrollDtoToJSON = ProfilePayrollDtoToJSON;
exports.ProfilePayrollDtoToJSONTyped = ProfilePayrollDtoToJSONTyped;
const PayrollStatus_1 = require("./PayrollStatus");
/**
 * Check if a given object implements the ProfilePayrollDto interface.
 */
function instanceOfProfilePayrollDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('timezone' in value) || value['timezone'] === undefined)
        return false;
    return true;
}
function ProfilePayrollDtoFromJSON(json) {
    return ProfilePayrollDtoFromJSONTyped(json, false);
}
function ProfilePayrollDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, PayrollStatus_1.PayrollStatusFromJSON)(json['status']),
        'timezone': json['timezone'],
    };
}
function ProfilePayrollDtoToJSON(json) {
    return ProfilePayrollDtoToJSONTyped(json, false);
}
function ProfilePayrollDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, PayrollStatus_1.PayrollStatusToJSON)(value['status']),
        'timezone': value['timezone'],
    };
}
//# sourceMappingURL=ProfilePayrollDto.js.map